const ProductReducer = (state, action) =>{
 
        switch (action.type) {
            case "SET_LOADING":
        return {
            ...state,
            isLoading:true,
        };
        case "SET_API_DATA":
            // const product= action.payload.filter((curElem)=>{
            //     return curElem.productsCategory != "";
            // })
            return{
                ...state,
                isLoading:false,
                products:action.payload,
                // productsCategory: product,
            };

        case "AVANSISBD_API_ERROR":
            return {
            ...state,
            isLoading:false,
            isError:true,
        };
    // Sigle product Reducer
        case "SET_SINGLE_PRODUCT_LOADING":
            return{
                ...state,
                singelProductLoading:true,
            }
        case "SET_SINGLE_PRODUCT_API":
            return {
                ...state,
                singelProductLoading:false,
                singleProduct:action.payload,
            };
                  
        case "SINGLE_PRODUCT_API_ERROR":
            return{
                ...state,
                singelProductLoading:false,
                isError:true
            }
        case "SET_LOADIN_API_DATA":
            return{
                ...state,
                isLoadingApiData:true
            }
        case "SET_GET_ANY_DATA":
            return{
                ...state,
                isLoadingApiData:false,
                apiData:action.payload,
            }
        case "SET_GET_ERROR":
            return{
                ...state,
                apiData:false,
                isError:true
            } 
    
            case "SET_LOADIN_NEV_DATA":
                return{
                ...state,
                isLoadingNEV:true
                }
            case "SET_GET_NEV_DATA":
                return{
                ...state,
                isLoadingNEV:false,
                getNewsEventData:action.payload,
            }
            case "SET_NEV_ERROR":
                return{
                    ...state,
                    isError:true,
                    getNewsEventData:false
                }
            case "SET_LOADIN_AVANSIS_DATA":
                return{
                    ...state,
                    isLoadingAvansis:true
                }

            case "SET_GET_AVANSIS_DATA":
               return{
                ...state,
                isLoadingAvansis:false,
                Avansis:action.payload,
               }
            case "SET_AVANSIS_ERROR":
                return{
                    ...state,
                    isError:true,
                    Avansis:false
                }
                
        case "SET_GET_MSG_DATA":
            return{
                ...state,
                wellcomMsg:action.payload,
            }
        case "SET_GET_PCATEGORY_DATA":
                return{
                    ...state,
                    productCategory:action.payload,
                }
        case "SET_DEVHISTORY_DATA":
                return{
                    ...state,
                    devHistory:action.payload
                }
        
        case "SET_LOADIN_JOB":
            return{
                ...state,
                isLoadingJob:true
            }
        case "SET_JOB_DATA":
            return{
                ...state,
                jobData:action.payload,
            }

        case "SET_JOB_ERROR":
            return{
                ...state,
                isError:true,
                jobData:false,
            }    
            // default:state;
        }
        

return state;
}
export default ProductReducer;